<script setup>
import { RouterView } from 'vue-router'
console.log('start App')
</script>

<template>
    <div class="full-height">
        <RouterView />
    </div>
</template>

<style>
@import "./assets/base.css";
@import "./assets/style.css";

.category { text-transform: capitalize; }
</style>
